// removed by extract-text-webpack-plugin
module.exports = {"value":"_1zJO4XuvX5-K9kBfWsv8Dz","avatar":"_3zrTEHjUIo1gKqJ8B4pOZP","permissionLevel":"_14TpQ6lR-6tAVz7n0Nz3I3","removeBtn":"_10eqqENjYv-0eHy0pZQmN8","team":"_2MrT_V2YIusu75GZMzgxgA","label":"_31_aCNH34iJiIUgFTZuCqa"};


//////////////////
// WEBPACK FOOTER
// ./src/components/tagValue.less
// module id = 627
// module chunks = 0